<template>
    <div>
        <div class="options d-flex align-items-center m-3 justify-content-between">
            <!-- <search table="extras"></search> -->

            <div class="d-flex col-sm-3 pl-0">
                <div class="d-flex w-100">
                    <input class="glued-right bg-lighter w-100" type="text" v-model="searchQuery" placeholder="Search">
                    <div class="glued-left dark"><i class="ico-search larger color-1"></i></div>
                </div>
            </div>

            <button class="btn" @click="addService">
                <i class="ico ico-add"></i> Add Service
            </button>

            <!-- <export></export> -->
        </div>

        <div v-if="getLoadingExtras" class="p-4 text-center">
            <loader></loader>
        </div>
        <div v-else>
            <list :header="header" :body="body" :rows="filteredResults" :actions="actions"></list>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import List from '@/tools/list/baseList'
    import Search from '@/tools/Search'
    import Export from '@/tools/Export'
    import Loader from '@/tools/loaders/loader1'

    export default {
        data: function() {
            return {
                searchQuery: null,
                body: {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    customCells: {
                        name: this.formatName,
                        code: this.formatCode,
                        priceTotal: this.formatPriceRange,
                        usedBy: this.formatUsedBy,
                        tax: this.formatTax,
                        isActive: this.formatIsActive,
                    },
                    customRowEvent: this.view,
                },
                actions: {
                    label : 'Actions',
                    list: [
                        {
                            slug: 'edit',
                            title: 'Edit',
                            tooltip: 'Edit',
                            params: '',
                            class: '',
                            icon: 'ico-edit largest',
                            event: this.view,
                        },
                        {
                            slug: 'delete',
                            title: 'Delete',
                            tooltip: 'Delete',
                            params: '',
                            class: '',
                            icon: 'ico-delete largest',
                            event: this.remove,
                        }
                    ],
                },
                rowEvent: null,
            }
        },
        computed: {
            ...mapGetters([
                'getExtras',
                'getExtrasLabels',
                'account',
                'getLoadingExtras'
            ]),
            header: function() {
                return {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    list: this.getExtrasLabels,
                };
            },
            filteredResults: function() {
                if(this.searchQuery){
                    return this.getExtras.filter(extra => {
                        return extra.name.toLowerCase().includes(this.searchQuery.toLowerCase())
                    })
                } else {
                    return this.getExtras
                }
            }
        },
        created: function(){
            console.log('CREATED EXTRAS LIST');
            // this.initExtras()
        },
        methods: {
            ...mapActions([
                'openModal',
                'initExtras',
                'removeItem',
                'setSelectedItem',
                'setSelectedExtra',
            ]),
            view: function(item) {
                if (item.id !== undefined) {
                    this.setSelectedExtra(item);
                    this.openModal('ExtraView');
                }
            },
            addService: function(){
                this.openModal('ExtraAdd')
            },
            remove: function(item) {
                this.removeItem({
                    table: 'extras',
                    object: 'extra',
                    module: 'inventory',
                    fields: { supplierId: this.account.supplierId, Extra: item }
                });
            },
            multiLevelHtml: function(top, bottom) {
                return '<div>' + top + '</div><div class="sub">' + bottom + '</div>';
            },
            formatMoney: function(value) {
                return value ? (parseFloat(value).toFixed(2) + '€') : 'N/A';
            },
            formatName: function(extra) {
                return '<div class="bold">' + extra.name + '</div>';
            },
            formatCode: function(extra) {
                return '<div class="bold">' + extra.code? extra.code : '' + '</div>';
            },
            formatPriceTotal: function(extra) {
                return this.formatMoney(extra.priceTotal);
            },
            formatUsedBy: (extra) => {
                return extra.usedBy ? (extra.usedBy + (extra.usedBy !== 1 ? ' Products' : ' Product')) : 'N/A';
            },
            formatTax: (extra) => {
                return extra.tax ? extra.tax.label : '-'
            },
            formatIsActive: function(extra) {
                return extra.isActive ? 'Active' : '<div class="color-6">Inactive</div>';
            },
            formatPriceRange: function(extra) {
                let lowerPrice = extra.prices[0].grossprice
                let higherPrice = extra.prices[0].grossprice

                extra.prices.map(price => {
                    higherPrice = (price.grossprice > higherPrice)? price.grossprice : higherPrice
                    lowerPrice = (price.grossprice < lowerPrice)? price.grossprice : lowerPrice
                })


                if(lowerPrice == higherPrice){
                    return higherPrice + '€'
                } else {
                    return lowerPrice + '€ to ' + higherPrice +'€'
                }
            }
        },
        components: {
            List,
            Search,
            Export,
            Loader
        },
    }
</script>



// WEBPACK FOOTER //
// Extras.vue?336fb3be